import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {
  AttachmentRule,
  DigitalAddressDto,
  DigitalAddressSearchParams,
  Page,
  Pageable
} from "../../generated-model/model";
import {IgnoreNullHttpParams} from "../shared/commons/Ignore-null-http-params";
import {environment} from "../../environments/environment";
import {PageRequest} from "../app.constants";

@Injectable({providedIn: "root"})
export class DigitalAddressResource {
  http = inject(HttpClient);

  search(req:DigitalAddressSearchParams,pageRequest: PageRequest){
    let httpParams = IgnoreNullHttpParams.fromObject({
      ...req,
      ...pageRequest
    }).toHttpParam();
    return this.http.get<Page<DigitalAddressDto>>(`${environment.serverUrl}/api/digital-address/search`, {params: httpParams});

  }
}
